// Angular
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PrimeNgModule } from "@primeng";

// BBWT
import { GridModule } from "@features/grid";
import { FilterModule } from "@features/filter";
import { BbCardModule } from "@features/bb-card";

import { MiproSharedModule } from "@mipro/mipro-shared.module";
import { DiagnosisModule } from "@project/diagnosis/diagnosis.module";
import { EpisodeHeadComponent } from "./episode-head.component";
import { EpisodeSelectDialogComponent } from "./episode-select/episode-select-dialog.component";
import { EpisodeSelectControlComponent } from "./episode-select/episode-select-control.component";
import { EpisodeHeaderComponent } from "./episode-header.component";
import { EpisodeDocumentRibbonComponent } from "./ribbons/episode-document-ribbon.component";
import { DuplicateEpisodesDialogComponent } from "./duplicate-episode-dialog.component";
import { EpisodeDialogComponent } from "./episode-dialog.component";
import { DuplicateEpisodeRibbonComponent } from "./duplicate-episode-ribbon.component";
import { TagModule } from "primeng/tag";
import { PlayerSharedModule } from "@project/player/player-shared.module";
import { RavenModule } from "@main/raven/raven.module";
import { EpisodeHeaderTitleComponent } from "./episode-header-title.component";
import { EpisodeHeaderTitleV3Component } from "./episode-header-title-v3.component";

import { EpisodeHeaderActionsComponent } from "./episode-header-actions.component";
import { MergeEpisodesDialogComponent } from "./merge-episode-dialog.component";
import { MoveEpisodeSubentityDialogComponent } from "./move-episode-subentity-dialog.component";
import { ConsultationMergeMoveModule } from "@project/consultation-merge-move/consultation-merge-move.module";
import { MergedEpisodeOverlayComponent } from "./merged-episode-overlay.component";
import { EpisodeFormRibbonComponent } from "./ribbons/episode-form-ribbon.component";
import { FormIODataService } from "@features/bb-formio/services/formio-data.service";
import { FormIOCategoryService } from "@main/formio/services/formioCategory.service";
import { FormIORevisionService } from "@features/bb-formio/services/formio-revision.service";
import { FormioVariableProviderService } from "@main/formio/services/formio-variable-provider.service";
import { MultiUserFormAssociationsService } from "@main/formio/multi-user-form/services/multi-user-form-associations.service";
import { MultiUserFormService } from "@main/formio/multi-user-form/services/multi-user-form.service";
import { EpisodeFormDraftRibbonComponent } from "@project/episode/ribbons/episode-form-draft.ribbon.component";
import { DashboardModule } from "../../main/reporting.v3/dashboard/dashboard.module";
import { AsyncMenuComponent } from "@project/prescription-shared/async-menu";
import { DocumentsRequestedRibbonComponent } from "@project/document-upload-request/ribbon/ribbon.component";

@NgModule({
    declarations: [
        EpisodeHeadComponent,
        EpisodeSelectDialogComponent,
        EpisodeSelectControlComponent,
        EpisodeHeaderComponent,
        DuplicateEpisodesDialogComponent,
        DuplicateEpisodeRibbonComponent,
        EpisodeDialogComponent,
        EpisodeHeaderTitleComponent,
        EpisodeHeaderTitleV3Component,
        EpisodeHeaderActionsComponent,
        MergeEpisodesDialogComponent,
        MoveEpisodeSubentityDialogComponent,
        MergedEpisodeOverlayComponent,
        EpisodeFormRibbonComponent,
        EpisodeFormDraftRibbonComponent
    ],
    imports: [
        ReactiveFormsModule,
        CommonModule,
        FormsModule,
        PrimeNgModule,
        MiproSharedModule,
        TagModule,
        // BBWT modules
        GridModule,
        FilterModule,
        BbCardModule,
        RavenModule,
        DiagnosisModule,
        DashboardModule,
        PlayerSharedModule,
        ConsultationMergeMoveModule,
        AsyncMenuComponent,
        DocumentsRequestedRibbonComponent
    ],
    exports: [
        EpisodeHeadComponent,
        EpisodeSelectDialogComponent,
        EpisodeSelectControlComponent,
        EpisodeHeaderComponent,
        DuplicateEpisodesDialogComponent,
        DuplicateEpisodeRibbonComponent,
        EpisodeDialogComponent,
        EpisodeHeaderTitleComponent,
        EpisodeHeaderTitleV3Component,
        EpisodeHeaderActionsComponent,
        MergeEpisodesDialogComponent,
        MoveEpisodeSubentityDialogComponent,
        MergedEpisodeOverlayComponent,
        EpisodeFormRibbonComponent,
        EpisodeFormDraftRibbonComponent
    ],

    providers: [
        FormIODataService,
        FormIOCategoryService,
        FormIORevisionService,
        FormioVariableProviderService,
        MultiUserFormAssociationsService,
        MultiUserFormService
    ],

    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EpisodeModule {}
